import {
    faArrowLeft,
    faArrowRight,
    faArrowsRotate,
    faArrowsUpToLine,
    faBars,
    faBell,
    faBook,
    faBookBookmark,
    faBookSkull,
    faBug,
    faCalendar,
    faCar,
    faChartBar,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faChevronRight,
    faChevronUp,
    faComments,
    faDatabase,
    faDownload,
    faEllipsisV,
    faExclamationCircle,
    faExpand,
    faExternalLinkAlt,
    faEye,
    faFlag,
    faFileContract,
    faFileLines,
    faFlask,
    faPaperclip,
    faFolder,
    faFolderOpen,
    faGear,
    faHelicopter,
    faHelmetSafety,
    faHome,
    faInfoCircle,
    faJetFighterUp,
    faLink,
    faLock,
    faMinus,
    faPaperPlane,
    faPen,
    faPhone,
    faPlane,
    faPlaneDeparture,
    faPlus,
    faPoundSign,
    faRobot,
    faRotateLeft,
    faSearch,
    faShieldHalved,
    faSignOutAlt,
    faSpinner,
    faStar,
    faStopwatch,
    faSyncAlt,
    faTable,
    faTimes,
    faTrash,
    faUpload,
    faUser,
    faUsers,
    faUsersCog,
    faWandMagicSparkles
} from "@fortawesome/free-solid-svg-icons";

import {
    FontAwesomeIcon
} from "@fortawesome/vue-fontawesome";
import {
    library
} from "@fortawesome/fontawesome-svg-core";

library.add(
    faBell,
    faPhone,
    faArrowLeft,
    faArrowRight,
    faFlask,
    faEye,
    faFlag,
    faBars,
    faHome,
    faHelicopter,
    faBookSkull,
    faBug,
    faDatabase,
    faChevronUp,
    faBookBookmark,
    faCheck,
    faComments,
    faSpinner,
    faJetFighterUp,
    faTimes,
    faChartBar,
    faTable,
    faPaperPlane,
    faPoundSign,
    faFolderOpen,
    faChevronDown,
    faCalendar,
    faCar,
    faStopwatch,
    faUser,
    faSearch,
    faShieldHalved,
    faStar,
    faSyncAlt,
    faUsers,
    faPlaneDeparture,
    faUsersCog,
    faSignOutAlt,
    faEllipsisV,
    faFileContract,
    faFileLines,
    faPaperclip,
    faLock,
    faExclamationCircle,
    faExpand,
    faExternalLinkAlt,
    faArrowsUpToLine,
    faPlane,
    faBook,
    faCheckCircle,
    faTrash,
    faDownload,
    faArrowsRotate,
    faInfoCircle,
    faHelmetSafety,
    faChevronRight,
    faFolder,
    faMinus,
    faPen,
    faPlus,
    faLink,
    faGear,
    faRobot,
    faRotateLeft,
    faUpload,
    faWandMagicSparkles
);

export default FontAwesomeIcon;
